import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleStopFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m9,1C4.5889,1,1,4.5889,1,9s3.5889,8,8,8,8-3.5889,8-8S13.4111,1,9,1Zm3.5,9.75c0,.9648-.7852,1.75-1.75,1.75h-3.5c-.9648,0-1.75-.7852-1.75-1.75v-3.5c0-.9648.7852-1.75,1.75-1.75h3.5c.9648,0,1.75.7852,1.75,1.75v3.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleStopFill18.js.map